<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.metersEditedItem.REFERENCE"
                        label="REFERENCE (*)"
                        :rules="[() => !!$store.state.metersEditedItem.REFERENCE]"
                        :error-messages="$store.state.errorMessages"
                        required
                   ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.metersEditedItem.DESC_NL"
                        label="DESC_NL (*)"
                        :rules="[() => !!$store.state.metersEditedItem.DESC_NL]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.metersEditedItem.DESC_FR"
                        label="DESC_FR (*)"
                        :rules="[() => !!$store.state.metersEditedItem.DESC_FR]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.metersEditedItem.TYPE"
                        label="TYPE (*)"
                        :rules="[() => !!$store.state.metersEditedItem.TYPE]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.metersEditedItem.COMPATIBILITY"
                        label="COMPATIBILITY (*)"
                        :rules="[() => !!$store.state.metersEditedItem.COMPATIBILITY]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-slider
                        v-model="$store.state.metersEditedItem.CT_NUMBER"
                        label="CT_QUANTITY (*)"
                        :tick-labels="ctQuantityLabels"
                        :max="3"
                        :min="0"
                        step="1"
                        ticks="always"
                        tick-size="4"
                    ></v-slider>                    
                </v-col>
                <v-col v-if="$store.state.metersEditedItem.CT_NUMBER > 0"
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.metersEditedItem.CT"
                        label="CT_REFERENCE (*)"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col v-if="!$store.state.metersEditedItem.CT_NUMBER > 0"
                    cols="6"
                    sm="6"
                    md="6"
                >
                </v-col>
                <v-col
                    cols="12"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model.number="$store.state.metersEditedItem.I_MAX"
                        label="I_MAX A) (*)"
                        :rules="[numberInputsMin1Rule]"
                        :error-messages="$store.state.errorMessages"
                        type="number"
                        required
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireCompteurs",
		data: function () {
			return {
                ctQuantityLabels: ["0", "1", "2", "3"]
            }
        }
    }
</script>
